import CKEditor from '@ckeditor/ckeditor5-vue2'
import Vue from 'vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import { ObserveVisibility } from 'vue-observe-visibility'
import VueToast from 'vue-toast-notification'
import Vuex from 'vuex'
import { getAll as getAllCountries } from './services/CountryService'
import { fetchNotifications } from './services/NotificationsService'

require('./bootstrap')

window.Vue = require('vue')
window.moment = require('moment')

Vue.use(VueToast)
Vue.use(Vuex)
Vue.use(CKEditor)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default)
Vue.component('companies-list', require('./components/Company/CompaniesList.vue').default)
Vue.component('companies-list-landing', require('./components/Company/CompaniesListLanding.vue').default)
Vue.component('companies-list-dashboard', require('./components/Company/CompaniesListDashboard.vue').default)
Vue.component('companies-tab', require('./components/Company/CompaniesTab.vue').default)

Vue.component('resource-details', require('./components/Resources/ResourceDetails.vue').default)
Vue.component('resources-tab', require('./components/Resources/ResourceTab.vue').default)
Vue.component('resource-card', require('./components/Resources/ResourceCard').default)
Vue.component('resource-list', require('./components/Resources/ResourceList').default)

Vue.component('activate-account', require('./components/TeamMembers/ActivateAccount').default)
Vue.component('dashboard', require('./components/Dashboard/Dashboard').default)
Vue.component('staff-availability-item', require('./components/Dashboard/StaffAvailabilityItem').default)
Vue.component('virtual-office-overview', require('./components/Dashboard/VirtualOfficeOverview').default)
Vue.component('task-overview', require('./components/Task/TaskOverview').default)
Vue.component('task-item', require('./components/Task/Lists/Items/TaskItem').default)
Vue.component('playable-task-item', require('./components/Task/Lists/Items/PlayableTaskItem').default)
Vue.component('task-modal-remove', require('./components/Task/TaskModalRemove').default)
Vue.component('task-advance-overview', require('./components/Task/Advanced/AdvanceOverview').default)
Vue.component('task-advance', require('./components/Task/Advanced/TaskAdvance').default)
Vue.component('task-metrics', require('./components/Task/Advanced/TaskMetrics').default)
Vue.component('your-tasks', require('./components/Task/Details/YourTasks').default)
Vue.component('team-tasks', require('./components/Task/Details/TeamTasks').default)
Vue.component('company-tasks', require('./components/Task/Details/CompanyTask').default)

Vue.component('subtask', require('./components/Dashboard/External/Subtask').default)
Vue.component('open-tasks', require('./components/Task/OpenTasks').default)
Vue.component('open-tasks-detail', require('./components/Task/OpenTaskDetails').default)
Vue.component('wfh-toast', require('./components/Misc/Banner/Toast').default)

Vue.component('check-in-splash-screen', require('./components/UserAvailability/CheckInSplashScreen').default)
Vue.component('recent-staff-activity-list', require('./components/UserAvailability/RecentStaffActivityList').default)

Vue.component('team-members-skeleton', require('./components/TeamMembers/Skeleton').default)

Vue.component('add-new-users', require('./components/TeamMembers/AddNewUsers').default)
Vue.component('add-group-member', require('./components/TeamMembers/Teams/AddGroupMember').default)
Vue.component('add-team', require('./components/TeamMembers/Teams/AddTeam').default)
Vue.component('edit-team', require('./components/TeamMembers/Teams/EditTeam').default)
Vue.component('teams-list', require('./components/TeamMembers/Teams/TeamsList').default)

Vue.component('company-details', require('./components/Company/CompanyDetails').default)
Vue.component('company-profile', require('./components/Company/Profile').default)
Vue.component('company-profile-detail', require('./components/Company/CompanyProfileDetail').default)
Vue.component('edit-company-profile', require('./components/Company/EditProfile/EditProfile').default)
Vue.component('edit-company-details', require('./components/Company/EditProfile/Details').default)
Vue.component('edit-company-remote-readiness', require('./components/Company/EditProfile/RemoteReadiness').default)

Vue.component('admin-dashboard', require('./components/Admin/Dashboard').default)
Vue.component('employee-compliance', require('./components/Admin/EmployeeCompliance').default)
Vue.component('employee-compliance-all', require('./components/Admin/EmployeeComplianceAll').default)
Vue.component('employee-compliance-item', require('./components/Admin/EmployeeComplianceItem').default)
Vue.component('employee-compliance-filter', require('./components/Admin/EmployeeComplianceFilter').default)

Vue.component('empty-state', require('./components/EmptyState').default)
Vue.component('empty-state', require('./components/EmptyState').default)

Vue.component('user-profile', require('./components/User/UserProfile').default)

Vue.component('remote-readiness-banner', require('./components/Misc/RemoteReadinessBanner').default)
Vue.component('edit-remote-readiness', require('./components/RemoteReadiness/RemoteReadiness').default)
Vue.component('setup-remote-readiness', require('./components/RemoteReadiness/SetupRemoteReadiness').default)
Vue.component('input-password', require('./components/Misc/InputPassword').default)

Vue.component('profile-setting', require('./components/User/ProfileSetting').default)

Vue.component('office-select', require('./components/Offices/OfficeSelect').default)
Vue.component('office-select-modal', require('./components/Offices/OfficeSelectModal').default)

Vue.component('activity-feed', require('./components/ActivityFeed/ActivityFeed').default)
Vue.component('activity-feed-post', require('./components/ActivityFeed/ActivityFeedPost').default)

Vue.component('dashboard-company-listing', require('./components/Dashboard/CompanyListing/CompanyListing').default)
Vue.component('dashboard-company-details', require('./components/Dashboard/CompanyListing/CompanyDetails').default)

/** Navigation */
Vue.component('navigation-bar', require('./components/Misc/Navigation/NavigationBar').default)
Vue.component('dashboard-bottom-navbar', require('./components/Misc/DashboardBottomNavBar').default)
Vue.component('dashboard-footer', require('./components/Misc/DashboardFooter').default)
Vue.component('navigation-bar-tribesuite', require('./components/Misc/Navigation/NavigationBarTribesuite').default)

/** Misc */
Vue.component('page-loader', require('./components/Misc/Loader').default)

Vue.component('remote-readiness', require('./components/Admin/RemoteReadiness').default)
Vue.component('remote-readiness-all', require('./components/Admin/RemoteReadinessAll').default)
Vue.component('remote-readiness-item', require('./components/Admin/RemoteReadinessItem').default)
Vue.component('search-filter', require('./components/Misc/SearchFilter').default)

Vue.component('actions-fab', require('./components/UserAvailability/ActionsFAB').default)

Vue.component('sign-in', require('./components/Auth/SignIn').default)
Vue.component('sign-up', require('./components/Auth/Register').default)
Vue.component('forgot-password', require('./components/Auth/ForgotPassword').default)
Vue.component('reset-password', require('./components/Auth/ResetPassword').default)

Vue.component('staff-selection', require('./components/TeamMembers/Modal/StaffSelection').default)
Vue.component('productivity-chart', require('./components/ActivityFeed/ProductivityChart').default)
Vue.component('add-label-modal', require('./components/TeamMembers/Modal/AddLabelModal').default)

Vue.component('external-task-overview', require('./components/Dashboard/External/TaskOverview').default)
Vue.component('info-banner', require('./components/Misc/Banner/InfoBanner').default)

// Landing Page tribesuite recruitment tab
Vue.component('landing-tab', require('./components/Misc/TribesuiteLanding/LandingTab/LandingTab').default)
Vue.component('testimoni-carousel', require('./components/Misc/TribesuiteLanding/TestimoniSection/TestimoniCarousel').default)
Vue.component('product-bundle-section', require('./components/Misc/TribesuiteLanding/ProductBundle/ProductBundleSection').default)

Vue.component('user-directory', require('./components/User/UserDirectory').default)

Vue.component('onboarding-company-form', require('./components/Company/Onboarding/CompanyForm').default)
Vue.component('onboarding-user-role-form', require('./components/Company/Onboarding/UserRoleForm').default)
Vue.component('onboarding-user-form', require('./components/Company/Onboarding/UserForm').default)
Vue.component('onboarding-company-readiness-form',
    require('./components/Company/Onboarding/CompanyReadinessForm').default)
Vue.component('onboarding-company-work-readiness-form',
    require('./components/Company/Onboarding/CompanyWorkReadinessForm').default)
Vue.component('onboarding-preview-details',
    require('./components/Company/Onboarding/PreviewOnboardingDetails').default)
Vue.component('image-uploader', require('./components/Misc/ImageUploader').default)
Vue.component('onboarding-progress-bar', require('./components/Company/Onboarding/OnboardingProgressBar').default)
Vue.component('preview-company-summary', require('./components/Company/Onboarding/PreviewCompanySummary').default)

Vue.component('custom-field-modal', require('./components/Misc/Modal/CustomFieldModal').default)
Vue.component('advanced-task-filter-modal', require('./components/Misc/Modal/AdvancedTaskFilter').default)
Vue.component('task-comments', require('./components/Task/Advanced/TaskComments').default)

Vue.component('company-card', require('./components/Company/CompanyCard').default)

Vue.component('admin-finance-report-summary', require('./components/FinanceReport/Admin/FinanceReport').default)
Vue.component('admin-task-report', require('./components/FinanceReport/Admin/TaskReport').default)
Vue.component('admin-staff-report', require('./components/FinanceReport/Admin/StaffsReport').default)
Vue.component('admin-tasks', require('./components/FinanceReport/Admin/List/TasksList').default)
Vue.component('admin-staffs', require('./components/FinanceReport/Admin/List/StaffsList').default)
Vue.component('admin-staff-details', require('./components/FinanceReport/Admin/StaffDetails').default)
Vue.component('admin-task-details', require('./components/FinanceReport/Admin/TaskDetails').default)

Vue.component('staff-report-summary', require('./components/TeamMembers/Report/ReportSummary').default)
Vue.component('staff-task-report', require('./components/TeamMembers/Report/TaskReport').default)
Vue.component('staff-tasks', require('./components/TeamMembers/Report/List/TasksList').default)
Vue.component('staff-task-details', require('./components/TeamMembers/Report/TaskDetails').default)
Vue.component('staff-task-log', require('./components/TeamMembers/Report/TaskLog').default)

// Atom components
Vue.component('currency-selection', require('./atoms/CurrencySelection').default)
Vue.component('user-avatar', require('./atoms/UserAvatar').default)
Vue.component('selection-button', require('./atoms/SelectionButton').default)
Vue.component('checkbox', require('./atoms/Tasks/Checkbox').default)
Vue.component('page-selection-button', require('./atoms/PageSelectionButton').default)
Vue.component('stats-box', require('./atoms/StatsBox').default)
Vue.component('input-field', require('./atoms/InputField').default)
Vue.component('task-status-badge', require('./atoms/TaskStatusBadge').default)

// Molecule components
Vue.component('switchable-input', require('./molecules/SwitchableInput').default)
Vue.component('tab-navigation', require('./molecules/TabNavigation').default)
Vue.component('admin-task-item', require('./molecules/AdminTaskItem').default)
Vue.component('admin-staff-item', require('./molecules/AdminStaffItem').default)
Vue.component('staff-task-item', require('./molecules/StaffTaskItem').default)
Vue.component('date-filter-modal', require('./molecules/DateFilterModal').default)
Vue.component('notification-popup', require('./molecules/NotificationPopup').default)
Vue.component('default-modal', require('./molecules/Modal').default)

// Third Party Libs
Vue.component('v-ctk-datepicker', VueCtkDateTimePicker)
Vue.component('ckeditor-wfh', require('./components/CKEditorWFH').default)

// Custom Component
Vue.component('iframe-video', require('./components/Video.vue').default)

Vue.component('landing', require('./components/TribeSuite/Landing.vue').default)
Vue.component('module-permissions', require('./components/TribeSuite/ModulePermissions.vue').default)
Vue.component('ads-tracking', require('./components/AdsTracking.vue').default)

const store = new Vuex.Store({
    state: {
        currentUser: {},
        userTeams: [],
        companyTeams: [],
        timezone: null,
        isAdmin: false,
        isSuperAdmin: false,
        isExternal: false,
        isPickUpTask: false,
        isLoading: true,
        labelOptions: [],
        currencyOptions: [],
        notifications: [],
        totalNotifications: 0,
        totalUnreadNotifications: 0,
        currentNotificationPage: 1,
        landingServiceSelected: 1,
    },

    mutations: {
        async setCurrentUser(state) {
            const data = await axios.get('/me').then(data => data.data.data)
            const roleSlugs = data.role.map((role) => {
                return role.slug
            });

            state.currentUser = data
            state.timezone = data.office_timezone?.zone_name ?? null
            state.isAdmin = roleSlugs.includes('admin')
            state.isSuperAdmin = roleSlugs.includes('super-admin')
            state.isExternal = roleSlugs.includes('freelancer')
            state.isPickUpTask = data.role.filter((role) => {
                return role.slug === 'freelancer' && role.pivot.type === 'pick-up-task'
            }).length > 0
            state.labelOptions = data.labels

            window.Echo.private(`notifications.received.${data.id}`).listen(
                '.notifications-received',
                async () => {
                    const response = await fetchNotifications({
                        per_page: state.currentNotificationPage * 3,
                        page: 1,
                    })

                    const unreadResponse = await fetchNotifications({
                        status: 'unread',
                    })

                    state.totalUnreadNotifications = unreadResponse.data.data.total
                    state.notifications = response.data.data.data
                    state.totalNotifications = response.data.data.total
                },
            )
        },

        async setUserTeam(state) {
            state.userTeams = await axios.get('/get-user-groups').then(data => data.data.data)
        },

        async setCompanyTeams(state) {
            state.companyTeams = await axios.get('/groups').then(res => res.data.data)
        },

        setLandingServiceOption(state, optionId) {
            state.landingServiceSelected = parseInt(optionId);
        },

        setLoadingStatus: _.debounce(function (state, status) {
            state.isLoading = status
        }, 400),

        async setCurrencyOptions(state) {
            const countries = await getAllCountries()

            state.currencyOptions = countries.data.map((country) => {
                return {
                    country_name: country.country,
                    currency_code: country.currency,
                }
            })
        },

        async getUserNotifications(state, param = {}) {
            const response = await fetchNotifications(param)

            if (!!param.page) {
                state.notifications = state.notifications.concat(response.data.data.data)
            } else {
                state.notifications = response.data.data.data
            }

            state.totalNotifications = response.data.data.total
            state.currentNotificationPage = response.data.data.current_page
        },

        setNotifications(state, payload) {
            state.notifications = payload
        },

        async updateUnreadNotifications(state) {
            const response = await fetchNotifications({
                status: 'unread',
            })

            state.totalUnreadNotifications = response.data.data.total
        },
    },

    actions: {
        setCurrentUser(context) {
            context.commit('setCurrentUser')
        },

        setUserTeam(context) {
            context.commit('setUserTeam')
        },

        setCompanyTeams(context) {
            context.commit('setCompanyTeams')
        },

        setLoadingStatus(context, payload) {
            context.commit('setLoadingStatus', payload)
        },

        setCurrencyOptions(context) {
            context.commit('setCurrencyOptions')
        },

        getUserNotifications(context, payload) {
            context.commit('getUserNotifications', payload)
        },

        setNotifications(context, payload) {
            context.commit('setNotifications', payload)
        },

        updateUnreadNotifications(context) {
            context.commit('updateUnreadNotifications')
        },

        setLandingServiceOption(context, optionId) {
            context.commit('setLandingServiceOption', optionId)
        }
    },
})

store.dispatch('setCurrentUser')
store.dispatch('setCompanyTeams')
store.dispatch('setUserTeam')
store.dispatch('getUserNotifications')
store.dispatch('setNotifications')
store.dispatch('updateUnreadNotifications')

// ziggy
Vue.mixin({ methods: { route } })

const app = new Vue({
    el: '#app',

    store,

    created() {
        // this.$store.commit('getCurrentUser');
    },

    data: {
        isLoading: false,
        axiosInterceptor: null,
    },

    methods: {
        enableInterceptor() {
            this.axiosInterceptor = axios.interceptors.request.use(
                (config) => {
                    store.dispatch('setLoadingStatus', true)
                    return config
                }, (error) => {
                    store.dispatch('setLoadingStatus', false)
                    return Promise.reject(error)
                })

            axios.interceptors.response.use((response) => {
                store.dispatch('setLoadingStatus', false)
                return response
            }, function (error) {
                store.dispatch('setLoadingStatus', false)
                return Promise.reject(error)
            })

            this.disableInterceptor()
        },

        disableInterceptor() {
            axios.interceptors.request.eject(this.axiosInterceptor)
        },
    },

    mounted() {
        this.enableInterceptor()
        store.dispatch('setLoadingStatus', false)
    },
})

let handleOutsideClick

Vue.directive('closable', {
    bind(el, binding, vnode) {
        // Here's the click/touchstart handler
        // (it is registered below)
        handleOutsideClick = (e) => {
            e.stopPropagation()
            // Get the handler method name and the exclude array
            // from the object used in v-closable
            const { handler, exclude } = binding.value

            // This variable indicates if the clicked element is excluded
            let clickedOnExcludedEl = false
            exclude.forEach(refName => {
                // We only run this code if we haven't detected
                // any excluded element yet
                if (!clickedOnExcludedEl) {
                    // Get the element using the reference name
                    const excludedEl = vnode.context.$refs[refName]
                    // See if this excluded element
                    // is the same element the user just clicked on
                    if (excludedEl) {
                        clickedOnExcludedEl = excludedEl.contains(e.target)
                    }
                }
            })

            // We check to see if the clicked element is not
            // the dialog element and not excluded
            if (!el.contains(e.target) && !clickedOnExcludedEl) {
                // If the clicked element is outside the dialog
                // and not the button, then call the outside-click handler
                // from the same component this directive is used in
                vnode.context[handler]()
            }
        }
        // Register click/touchstart event listeners on the whole page
        document.addEventListener('click', handleOutsideClick)
        document.addEventListener('touchstart', handleOutsideClick)
    },
})

Vue.directive('observe-visibility', ObserveVisibility)
